const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "431.796 -55.755 514.947 613.08",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 937.581 195.161 C 937.581 303.102 873.559 367.658 806.676 434.94 C 766.263 474.214 727.304 514.888 688.272 555.556 C 649.32 514.888 610.289 474.214 569.874 434.94 C 503.065 367.658 437.927 303.102 437.927 195.161 C 437.927 162.236 444.392 129.632 456.956 99.214 C 469.52 68.798 487.931 41.161 511.151 17.881 C 534.364 -5.404 561.925 -23.866 592.253 -36.464 C 622.587 -49.069 655.095 -55.555 687.927 -55.555 C 720.759 -55.555 753.267 -49.069 783.6 -36.464 C 813.927 -23.866 841.488 -5.404 864.71 17.881 C 887.923 41.161 906.333 68.798 918.904 99.214 C 931.468 129.632 937.927 162.236 937.927 195.161 L 937.581 195.161 Z",
    fill: "white",
    style: {
      transformOrigin: "644.176px 250px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(0.7183709740638733, 0, 0, -0.7299069166183472, 473.10593654009296, 325.6697456713723)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3168.972 5072.576 L 5933.432 284.377 C 5970.652 219.904 5970.652 140.475 5933.432 76.006 C 5896.222 11.556 5827.432 -28.166 5752.992 -28.166 L 224.056 -28.166 C 149.61 -28.166 80.833 11.556 43.61 76.006 C 6.396 140.475 6.396 219.904 43.61 284.377 L 2808.082 5072.576 C 2845.302 5137.046 2914.092 5176.756 2988.522 5176.756 C 3062.962 5176.756 3131.742 5137.046 3168.972 5072.576",
    style: {
      fill: "#f14824",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3154.35,5101.82 5918.81,313.621 c 37.22,-64.473 37.22,-143.902 0,-208.371 C 5881.6,40.8008 5812.81,1.07813 5738.37,1.07813 H 209.434 c -74.446,0 -143.2231,39.72267 -180.4457,104.17187 -37.21486,64.469 -37.21486,143.898 0,208.371 L 2793.46,5101.82 c 37.22,64.47 106.01,104.18 180.44,104.18 74.44,0 143.22,-39.71 180.45,-104.18 z",
    style: {
      fill: "none",
      stroke: "#f14824",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5016.61,626.148 H 931.199 L 2973.9,4164.21 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5016.61,626.148 H 931.199 L 2973.9,4164.21 Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.10032,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3567.72 1579.88 L 3567.72 778.949 L 2384.964 788.697 L 2380.09 1587.13 C 2507.26 1793.93 2733.18 1919.32 2975.95 1917.85 C 3218.71 1916.35 3443.09 1788.22 3567.72 1579.88",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3567.72,1579.88 V 778.949 H 2380.09 v 808.181 c 127.17,206.8 353.09,332.19 595.86,330.72 242.76,-1.5 467.14,-129.63 591.77,-337.97 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 7.10032,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2255.07,778.949 h -437.55 v 438.371 h 437.55 V 778.949",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2255.07,778.949 h -437.55 v 438.371 h 437.55 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 6.07708,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2255.07,1283.03 h -437.55 v 569.95 l 437.55,-211.88 v -358.07",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2255.07,1283.03 h -437.55 v 569.95 l 437.55,-211.88 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 6.07708,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2282.36,1700.9 c 91.79,132.46 219.89,235.58 368.89,296.97 l -164.62,448.01 c -226.79,-160.15 -439.34,-339.57 -635.27,-536.27 l 431,-208.71",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2282.36,1700.9 c 91.79,132.46 219.89,235.58 368.89,296.97 l -164.62,448.01 c -226.79,-160.15 -439.34,-339.57 -635.27,-536.27 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 7.10032,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3233.99,2018.13 169.35,460.89 c -284.97,17.23 -570.82,14 -855.33,-9.65 l 164.94,-448.87 c 169.5,54.71 352.04,53.89 521.04,-2.37",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3233.99,2018.13 169.35,460.89 c -284.97,17.23 -570.82,14 -855.33,-9.65 l 164.94,-448.87 c 169.5,54.71 352.04,53.89 521.04,-2.37 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 7.10032,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3665.44,1700.9 431.01,208.71 c -195.95,196.7 -408.49,376.12 -635.27,536.27 l -164.62,-448.01 c 149,-61.39 277.1,-164.51 368.88,-296.97",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3665.44,1700.9 431.01,208.71 c -195.95,196.7 -408.49,376.12 -635.27,536.27 l -164.62,-448.01 c 149,-61.39 277.1,-164.51 368.88,-296.97 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 7.10032,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3692.73,1283.03 h 437.56 v 569.95 L 3692.73,1641.1 v -358.07",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3692.73,1283.03 h 437.56 v 569.95 L 3692.73,1641.1 Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 6.07708,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3692.73,778.949 h 437.56 V 1217.32 H 3692.73 V 778.949",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3692.73,778.949 h 437.56 v 438.371 h -437.56 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 6.07708,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunnel);
export default __webpack_public_path__ + "static/media/tunnel.4a4938cff0d83d660191bcae603edfaf.svg";
export { ForwardRef as ReactComponent };